import * as Yup from 'yup'

const pitchValidationSchema = Yup.object().shape({
  aboutYourself: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string()
      .required('Your bio is required.')
      .min(150, 'Your bio must be at least 150 characters.')
      .max(850, 'Your bio must be fewer than 850 characters.'),
  }),
  topIndustries: Yup.array()
    .of(Yup.string())
    .required('Please select at least 1 industry.')
    .max(5, 'May only select 5 tags.'),
  topFinancialSkills: Yup.array()
    .of(Yup.string())
    .required('Please select at least 1 skill.')
    .max(5, 'May only select 5 tags.'),
  topSoftwareSkills: Yup.array()
    .of(Yup.string())
    .required('Please select at least 1 software.')
    .max(5, 'May only select 5 tags.'),
  whyFreelanceWork: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string()
      .required('Field is required.')
      .min(150, 'Field must be at least 150 characters.')
      .max(850, 'Field must be fewer than 850 characters.'),
  }),
})

export default pitchValidationSchema
